/*
 * @author Oleksandr Papka <papkaos>
 */
angular.module('popup.system-package').directive('gccsPopupSystemDowngradeEmployees', [
  'popupDirectiveConfig',
  popupDirectiveConfig =>
    popupDirectiveConfig.configure({
      bodyTemplate: require('./template.pug')
    })
]);
